function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { STORAGE_KEYS as t } from "./storage-manager.js";
import u from "./subscription-manager.js";
import { logger as N, IndexedDBAdapter as it } from "../../shared-lib/index.js";

var qt = /*#__PURE__*/function () {
  function qt(t, i, s) {
    _classCallCheck(this, qt);

    this.C = t, this.gh = i, this.Fh = s, this.C = t, this.gh = i || !1, this.Fh = s, this.kh = new u(), this.fh = 0, this.wh = 1;
  }

  _createClass(qt, [{
    key: "jh",
    value: function jh() {
      return this.gh;
    }
  }, {
    key: "xh",
    value: function xh() {
      return this.C.ps(t.bs.qh);
    }
  }, {
    key: "setSdkAuthenticationSignature",
    value: function setSdkAuthenticationSignature(i) {
      var s = this.xh();
      this.C.js(t.bs.qh, i);
      var e = it.Gs._s;
      new it(e, N).setItem(e.Os.yh, this.wh, i), s !== i && this.es();
    }
  }, {
    key: "Bh",
    value: function Bh() {
      this.C.Ls(t.bs.qh);
      var i = it.Gs._s;
      new it(i, N).me(i.Os.yh, this.wh);
    }
  }, {
    key: "subscribeToSdkAuthenticationFailures",
    value: function subscribeToSdkAuthenticationFailures(t) {
      return this.Fh.Ns(t);
    }
  }, {
    key: "Gh",
    value: function Gh(t) {
      this.Fh.X(t);
    }
  }, {
    key: "Hh",
    value: function Hh() {
      this.kh.removeAllSubscriptions();
    }
  }, {
    key: "Jh",
    value: function Jh() {
      this.fh += 1;
    }
  }, {
    key: "Kh",
    value: function Kh() {
      return this.fh;
    }
  }, {
    key: "es",
    value: function es() {
      this.fh = 0;
    }
  }]);

  return qt;
}();

export { qt as default };